import apiClient from '../../lib/axios';
import { getAccessToken } from '../../utils/tokenStorage';

export const login = async (credentials) => {
  const { data } = await apiClient.post('/api/auth/login', credentials);
  return data;
};

/**
 * Verify OTP after login when OTP is required.
 * POST /api/auth/verify-otp with { email, otp }.
 * Returns { user, accessToken, refreshToken } on success (same shape as login).
 */
export const verifyOtp = async (payload) => {
  const { data } = await apiClient.post('/api/auth/verify-otp', payload);
  return data;
};

export const fetchProfile = async () => {
  const { data } = await apiClient.get('/api/auth/profile');
  return data;
};

export const requestPasswordReset = async (payload) => {
  const { data } = await apiClient.post('/api/auth/forgot-password', payload);
  return data;
};

export const resetPassword = async ({ token, body }) => {
  const { data } = await apiClient.post(`/api/auth/reset-password/${token}`, body);
  return data;
};

export const refreshToken = async () => {
  const { data } = await apiClient.post('/api/auth/refresh-token');
  return data;
};

export const logout = async (payload) => {
  try {
    const { data } = await apiClient.post('/api/auth/logout', payload || {});
    return data;
  } catch (error) {
    if (error.response?.status === 401) {
      return { success: true, message: 'Logged out successfully' };
    }
    throw error;
  }
};

export const register = async (payload) => {
  const { data } = await apiClient.post('/api/auth/register', payload);
  return data;
};

export const changePassword = async (payload) => {
  const accessToken = getAccessToken();
  const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
  const { data } = await apiClient.patch('/api/auth/change-password', payload, { headers });
  return data;
};
